import React, { useState } from 'react';
import { CVSheet } from '../components/cv/CVSheet';
import { ScaledSheet } from '../components/cv/ScaledSheet';
type Length = 'full' | 'one';
/** The print-ready A4 CV surface (body only — header/toggle/export live in App). */
export function CvView() {
  const [length, setLength] = useState<Length>('full');
  const compact = length === 'one';
  const opt = 'rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)]';
  return <div className="cv-view w-full bg-[#efe9e0]" data-id="element-313" data-mp="27mh96o66gky">
      <div className="print-stage flex flex-col items-center px-3 pb-8 pt-4 sm:px-4" data-id="element-314" data-mp="g5kuu9uo28ze">
        {/* length toggle — full multi-page vs. condensed one-page */}
        <div className="no-print mb-5 inline-flex items-center gap-0.5 rounded-full border border-[var(--line-strong)] bg-white/70 p-0.5" data-id="element-315" data-mp="b4eze49mg7m6">
          {(['full', 'one'] as const).map(v => <button key={v} type="button" aria-pressed={length === v} onClick={() => setLength(v)} className={`${opt} ${length === v ? 'bg-[var(--ink)] text-[var(--paper)]' : 'text-[var(--ink-soft)] hover:text-[var(--ink)]'}`} data-id="element-316" data-mp="2czpf8ro0k0r1">
              {v === 'full' ? 'Full CV' : 'One-page'}
            </button>)}
        </div>

        {/* key forces a clean re-measure/re-paginate when length changes */}
        <ScaledSheet key={length} data-id="element-317" data-mp="2vihhot99hkxv">
          <CVSheet compact={compact} data-id="element-318" data-mp="30hkgvx2k8wxx" />
        </ScaledSheet>
      </div>
    </div>;
}